/* @ngInject */
function AttachmentLogsCoreController ($scope, $rootScope, $translate, PostsService, Utils) {
  $scope.searchTerm = ''
  $scope.readGraphics = []
  $scope.filterUsers = {
    name: ''
  }
  $scope.dataLog = []
  $scope.flagsAttachmentLogs = {
    loadingData: false
  }

  const api = {
    _hideAssetLogs,
    _handleSuccessGetLog,
    _getDownloadLogFromObj,
    _generateReadGraphics
  }

  this.getApi = () => api

  $scope.getLogs = function () {
    const postId = $scope._postId
    const attachmentId = $scope.attachmentStatistics.id
    PostsService.getAttachmentLog(attachmentId, postId)
      .then(api._handleSuccessGetLog)
  }

  $scope.closeAttachmentLogs = function () {
    if ($rootScope.isDesktop) {
      const el = jQuery('.asset-logs')
      api._hideAssetLogs(el)
    }
  }

  $scope.clearSearch = function () {
    $scope.filterUsers.name = ''
  }

  $scope.onLastRepeaterItem = function () {
    jQuery('.dropdown-attachment-logs-list').dropdown({
      showOnFocus: false
    })
  }

  $scope.getDownloadIconTooltipText = function (data) {
    const downloadedLog = api._getDownloadLogFromObj(data)

    if (!downloadedLog) {
      return
    }

    return Utils.formatDateTooltipText('downloadedOn', downloadedLog.createdAt)
  }

  $scope.getClassForDownloadIcon = function (data) {
    const downloadedLog = api._getDownloadLogFromObj(data)

    if (!downloadedLog) {
      return ''
    }

    return 'green'
  }

  function _getDownloadLogFromObj (data) {
    if (!data.logs) {
      return
    }

    return data.logs.find(log => log.type === 'DOWNLOAD')
  }

  function _hideAssetLogs (element) {
    const animationMilliseconds = 500

    element.hide(animationMilliseconds)
    $scope.flagsAttachmentLogs.seeAttachmentLogs = false
  }

  function _handleSuccessGetLog (response) {
    const uniqueIndex = 'user_id'
    const groupedItems = Utils.groupBy(response, uniqueIndex)
    const data = groupedItems.map(userArr => {
      if (userArr.length >= 1 && userArr[0].type) {
        userArr[0].logs = userArr.map(user => {
          if (user.type === 'VIEW') {
            userArr[0].viewedAttachmentAt = user.createdAt
          }

          return {
            type: user.type,
            createdAt: user.createdAt
          }
        })
      }
      return userArr[0]
    })

    const key = 'role'
    $scope.dataLog = Utils.sortByKey(data.flat(), key)

    api._generateReadGraphics()
    $scope.loadingData = false
  }

  function _generateReadGraphics () {
    const getViewsProgress = (totalUsers, views) => Math.round((views / totalUsers) * 100) || 0
    const getDownloadsProgress = (totalUsers, downloads) => Math.round((downloads / totalUsers) * 100) || 0

    const totalUsers = $scope.dataLog.length
    const usersWhoViewed = $scope.dataLog.map(user => user.logs || []).flat().filter(logs => logs.type === 'VIEW').length
    const usersWhoDownloaded = $scope.dataLog.map(user => user.logs || []).flat().filter(logs => logs.type === 'DOWNLOAD').length
    $scope.readGraphics = []

    const progressWhoViewed = getViewsProgress(totalUsers, usersWhoViewed)
    const progressWhoDownloaded = getDownloadsProgress(totalUsers, usersWhoDownloaded)

    $scope.readGraphics.push({
      class: Utils.getClassForProgress(progressWhoDownloaded),
      progress: progressWhoDownloaded,
      icon: 'download',
      tooltipText: $translate.instant('downloads')
    })

    $scope.readGraphics.push({
      class: Utils.getClassForProgress(progressWhoViewed),
      progress: progressWhoViewed,
      icon: 'eye',
      tooltipText: $translate.instant('viewed')
    })
  }
}

export { AttachmentLogsCoreController }
